import { render, staticRenderFns } from "./AddCertification.vue?vue&type=template&id=458799e6&scoped=true"
import script from "./AddCertification.vue?vue&type=script&lang=js"
export * from "./AddCertification.vue?vue&type=script&lang=js"
import style0 from "./AddCertification.vue?vue&type=style&index=0&id=458799e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458799e6",
  null
  
)

export default component.exports